<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="table-bicolor">
    <table>
      <tr v-for="(el, i) in dataTable" :key="i" class="table-row">
        <td v-if="numeration" class="table-num">{{ i }}</td>
        <td class="table-element">{{ el.camp_name }}</td>
        <td class="table-description">
          <markdown-it-vue :content="el.description" :options="markDownOptions" />
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import MarkdownItVue from 'markdown-it-vue'
/**
 * Display a styled bicolor table with recived data
 * @example [none]
 */
export default {
  name: 'TableBicolor',
  components: { MarkdownItVue },
  props: {
    /**
     * Array with keys and values of the table
     */
    dataTable: {
      type: Array,
    },
    /**
     * Says if table has numeration or not
     */
    numeration: {
      type: Boolean,
    },
  },
  data() {
    return {
      markDownOptions: {
        markdownIt: {
          linkify: true
        },
        linkAttributes: {
          attrs: {
            target: '_blank',
            rel: 'noopener'
          }
        }
      },
    }
  },
}
</script>

<style lang="stylus" scoped>
.table-bicolor
  display: flex
  padding-bottom: vw(15px)

  table
    width: 100%
    border: none
    border-collapse: collapse

    td
      padding: vw(5px) vw(10px)

    tr
      &:hover
        background-color: #CFCFCF

    .table-row
      border: none
      background-color: $bcn-table-even

      &:nth-child(even)
        background-color: white

      &:hover
        background-color: $bcn-table-highlight

      .table-num
        m-font-size(18, 26)
        color: black
        font-weight: 400

      .table-element
        m-font-size(18, 26)
        color: black
        font-weight: 400

        .mobile &
          m-font-size(16, 20)

      .table-description
        m-font-size(16, 24)
        color: black
        font-weight: 300

        .mobile &
          m-font-size(14, 18)

        >>> a
          color: $corporate_color
</style>